<ng-container *ngIf="isCompanyLandingPage; else defaultLayout">
  <router-outlet></router-outlet>
</ng-container>

<ng-template #defaultLayout>
  <nz-layout
    class="full-height-layout"
    [ngClass]="{
    'login-mode': !showHeader && !isMobileDesktopPage,
    'landing-page': !showHeader && isLandingPage,
    'standalone-layout': isMobileDesktopPage || isAuthLinkErrorPage
  }">
    <app-platform-announcement-banner *ngIf="showHeader && !isAdmin"></app-platform-announcement-banner>

    <nz-layout class="content-layout">
      <!-- Sidebar shown when header is shown -->
      <nz-sider
        *ngIf="showHeader"
        [nzWidth]="200"
        [nzCollapsedWidth]="80"
        [nzCollapsed]="sidebarCollapsed"
        [nzCollapsible]="true"
        [nzTrigger]="null"
        [nzTheme]="theme ? 'dark' : 'light'"
        [ngClass]="theme ? 'dark-theme' : 'light-theme'"
        class="sidebar"
        data-tour="global-sidebar"
      >
        <app-sidebar
          [theme]="theme"
          [isCollapsed]="sidebarCollapsed"
          (isCollapsedChange)="onSidebarCollapsedChange($event)"
        ></app-sidebar>
      </nz-sider>

      <nz-layout class="authenticated-main-layout">
        <nz-header *ngIf="showHeader" class="header">
          <app-header [(theme)]="theme" (themeChange)="onThemeChange($event)"></app-header>
        </nz-header>

        <nz-content class="main-content" [ngClass]="{ 'standalone-content': isMobileDesktopPage || isAuthLinkErrorPage }">
          <div class="content-wrapper" [ngClass]="{
           'login-mode-wrapper': !showHeader && !isResetPasswordPage && !isMobileDesktopPage && !isAuthLinkErrorPage,
           'standalone-wrapper': isMobileDesktopPage || isAuthLinkErrorPage
          }">
            <app-progress *ngIf="showHeader && !isAdmin" (progressReached100)="onProgressUpdate($event)"
                          (visibilityChange)="onProgressVisibilityChange($event)"></app-progress>
            <app-onboarding-progress-widget *ngIf="showHeader && !isAdmin"></app-onboarding-progress-widget>
            <div id="routed-content-start" aria-hidden="true"></div>
            <router-outlet></router-outlet>
          </div>
        </nz-content>
      </nz-layout>
    </nz-layout>
  </nz-layout>
</ng-template>
<nz-back-top *ngIf="!isCompanyLandingPage && !isMobileDesktopPage && !isLoginPage && !isAuthLinkErrorPage"></nz-back-top>
